function pathToBreadcrumbs(root, path) {
    const p = path || '';
    const elements = p.split('/').filter(element => element.length > 0);

    return [root].concat(
        elements.map((element, index) => ({
            id: element,
            text: element,
            to: `${root.to}/${elements.slice(0, index + 1).join('/')}`,
        })),
    );
}

export {
    pathToBreadcrumbs,
};

export default {
};



// WEBPACK FOOTER //
// ./src/utils/breadcrumbs.js